import React, { useState } from "react";
import {
  Zap,
  Leaf,
  Recycle,
  Users,
  Shield,
  ArrowUpRight,
  Target,
} from "lucide-react";
import { priorities } from "../data/mock";

const iconMap = { Zap, Leaf, Recycle, Users, Shield };

export default function Priorities() {
  const [active, setActive] = useState(0);

  return (
    <section id="priorities" className="relative py-24 bg-gradient-to-b from-[#F0EFE8] to-[#FAF9F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#1F5943]/10 text-[#1F5943] mb-5">
            <Target className="w-4 h-4" />
            <span className="text-xs font-bold tracking-widest uppercase">Award Priorities</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-[#0f2a20] mb-4">
            Five sustainability priorities to win.
          </h2>
          <p className="text-[#3a5148] text-lg leading-relaxed">
            In addition to traditional operational metrics, labs must demonstrate
            equal commitment to all five priorities to earn recognition.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-6">
          {priorities.map((p, i) => {
            const Icon = iconMap[p.icon] || Leaf;
            const isActive = active === i;
            return (
              <div
                key={p.id}
                onMouseEnter={() => setActive(i)}
                className={`relative p-6 rounded-2xl bg-white border transition-all duration-500 cursor-pointer group ${
                  isActive
                    ? "border-transparent shadow-2xl -translate-y-2"
                    : "border-[#1F5943]/10 shadow-sm hover:shadow-lg"
                }`}
                style={{
                  boxShadow: isActive ? `0 20px 40px -20px ${p.accent}50` : undefined,
                }}
              >
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5 transition-transform group-hover:rotate-6"
                  style={{ background: p.bg }}
                >
                  <Icon className="w-7 h-7" style={{ color: p.accent }} strokeWidth={2.2} />
                </div>

                <div className="text-xs font-bold text-[#7a8b83] tracking-widest mb-2">
                  0{p.id}
                </div>
                <h3 className="font-display text-xl text-[#0f2a20] mb-3 leading-tight">
                  {p.title}
                </h3>
                <p className="text-[#3a5148] text-sm leading-relaxed mb-4">
                  {p.description}
                </p>

                <ul className="space-y-1.5 mb-4">
                  {p.points.map((pt) => (
                    <li key={pt} className="flex items-start gap-2 text-xs text-[#3a5148]">
                      <span
                        className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0"
                        style={{ background: p.accent }}
                      />
                      {pt}
                    </li>
                  ))}
                </ul>

                <div
                  className="absolute top-6 right-6 w-8 h-8 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{ background: p.bg }}
                >
                  <ArrowUpRight className="w-4 h-4" style={{ color: p.accent }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
